import Swiper from 'swiper'
import { A11y, EffectFade, Navigation, Pagination } from 'swiper/modules'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const setupSlider = (el) => {
  const container = el.querySelector('.swiper')

  const swiper = new Swiper(container, {
    modules: [A11y, EffectFade, Navigation, Pagination],
    speed: 500,
    pagination: {
      el: el.querySelector('.slider-pagination'),
      clickable: true,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    breakpoints: {
      768: {
        enabled: false,
      },
    },
  })

  container.querySelectorAll('.slider-button-next').forEach((btn) => {
    btn.addEventListener('click', () => swiper.slideNext())
  })
}

const setupScroller = (el) => {
  const contents = el.querySelectorAll('.callout-content')

  contents.forEach((content) => {
    const height = content.offsetHeight
    const styles = window.getComputedStyle(content)
    const margin = parseFloat(styles['marginTop'])

    content.setAttribute('data-height', height + margin)
  })

  gsap.set(contents, { height: 0 })

  const timeline = gsap.timeline({
    paused: true,
    scrollTrigger: {
      trigger: el,
      start: 'top center',
      end: 'bottom center',
      scrub: true,
      markers: false,
    },
  })

  contents.forEach((content) => {
    const bar = content.closest('.callout-cell').querySelector('.callout-bar')
    const gradient = content.closest('.callout-cell').querySelector('.callout-gradient')
    timeline.to(content, { height: content.dataset.height })
    timeline.to(bar, { backgroundColor: '#009ad0' }, '<')
    timeline.to(gradient, { opacity: 0 }, '<')
  })
}

export default {
  init: () => {
    document.querySelectorAll('.callout-blocks').forEach((el) => {
      setupSlider(el)

      if (window.matchMedia('(min-width: 768px)').matches) {
        setupScroller(el)
      }
    })
  },
}
